var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseRequisitions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.678,
    height: 24.677,
    viewBox: "0 0 24.678 24.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1666",
    "data-name": "Group 1666",
    transform: "translate(16951 2167.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1662",
    "data-name": "Group 1662",
    transform: "translate(-16951 -2167.137)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 12.339,
    cy: 12.339,
    r: 12.339,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2_",
    "data-name": "Vector (2)",
    d: "M11.542,5.859H10.327a.222.222,0,0,0-.214.162L9.542,8.079h-1.1V2.206a.221.221,0,0,0-.065-.157L6.387.065A.222.222,0,0,0,6.23,0H.222A.222.222,0,0,0,0,.221V10.94a.222.222,0,0,0,.222.221H4.94l.192.693a.222.222,0,0,0,.214.162h3.4a.222.222,0,0,0,.214-.162L10.5,6.3h1.047a.221.221,0,1,0,0-.443ZM6.451.756,7.682,1.985H6.451ZM.443,10.718V.443H6.008V2.206a.221.221,0,0,0,.222.221H8V8.079H4.376a.221.221,0,0,0-.214.28l.654,2.358H.443Zm8.129.855H5.514L4.668,8.522H9.419Zm-.182.681a.735.735,0,1,0,.736.735A.737.737,0,0,0,8.391,12.254Zm0,1.028a.292.292,0,1,1,.293-.292A.293.293,0,0,1,8.391,13.282ZM5.7,12.254a.735.735,0,1,0,.736.735A.737.737,0,0,0,5.7,12.254Zm0,1.028a.292.292,0,1,1,.293-.292A.293.293,0,0,1,5.7,13.282ZM2.691,1.985H1.184a.222.222,0,0,0-.222.221v1.5a.221.221,0,0,0,.222.221H2.691a.221.221,0,0,0,.222-.221v-1.5A.221.221,0,0,0,2.691,1.985Zm-.222,1.5H1.406V2.428H2.469Zm1.2-.436a.222.222,0,1,1,.313-.313l.353.352.739-.738a.222.222,0,0,1,.313.313l-.9.894a.222.222,0,0,1-.313,0ZM2.691,4.8H1.184a.222.222,0,0,0-.222.221v1.5a.221.221,0,0,0,.222.221H2.691a.221.221,0,0,0,.222-.221v-1.5A.222.222,0,0,0,2.691,4.8ZM2.469,6.3H1.406V5.24H2.469Zm1.709.073-.509-.509a.222.222,0,1,1,.313-.313l.353.352.739-.738a.222.222,0,0,1,.313.313l-.9.894a.222.222,0,0,1-.313,0ZM2.691,7.609H1.184a.222.222,0,0,0-.222.221v1.5a.222.222,0,0,0,.222.221H2.691a.221.221,0,0,0,.222-.221V7.83A.221.221,0,0,0,2.691,7.609Zm-.222,1.5H1.406V8.052H2.469Z",
    transform: "translate(-16943.945 -2161.465)",
    fill: "#e2496f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseRequisitions);
export default __webpack_public_path__ + "static/media/PurchaseRequisitions.75b4afa143384858f8741da457679d77.svg";
export { ForwardRef as ReactComponent };